import { LINK_FIELD } from './elements/link'
import { IMAGE } from './elements/assets'

export const FOOTER = `
footer: entries(
    section: "footerNavigation",
    site: $site,
    level: 1
) {
  id
  title

  ... on bottomNavigation_Entry {
    copyright

    button {
      title
      url
    }

    ${ IMAGE }

    businessInfo: textTable {
      id
      heading
      text
    }
  }

  children {
    id
    title
    ...on navItem_Entry {
      ${ LINK_FIELD }
    }
    
    children {
      id
      title
      ...on navItem_Entry {
        ${ LINK_FIELD }
      }
    }
  }
}
`